import React, { Component } from "react";
import AntdMenu, {MenuProps} from "antd/lib/menu";
import "antd/lib/menu/style";

const { Item, SubMenu, ItemGroup, Divider } = AntdMenu;
export default class Menu extends Component<MenuProps> {
  static Item = Item;
  static SubMenu = SubMenu;
  static ItemGroup = ItemGroup;
  static Divider = Divider;
  render() {
    return <AntdMenu {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/menu/index.tsx